module.exports = __webpack_public_path__ + "static/LWAF-a303af63a8a141a615b43c63c599f523.png";